import { Injectable } from '@angular/core';

import { ContractType } from '@dav-model/api/response/pending-contract.response.model';
import { ContractFilterDateType, ContractFilterStatusType, HistoryFilter } from '@dav-model/history-filter';

import { SortingService } from './sorting.service';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  static fetchContractGroup(contracts: ContractType[]) {
    // disable sorting (should not sort alphabetically)
    return contracts.reduce((prevVal, elem) => {
      const index = prevVal.some(item => item.name === elem.contractGroup1);
      if (!index) {
        prevVal.push(new ContractFilterDateType(elem.contractGroup1));
      }

      return prevVal;
    }, []);
  }

  static fetchStatus(contracts: ContractType[]) {
    const status = contracts.reduce((prevVal, elem) => {
      const index = prevVal.some(item => item.name === elem.status);
      if (!index) {
        prevVal.push(new ContractFilterStatusType(elem.status));
      }

      return prevVal;
    }, []);

    return SortingService.sortStrings(status);
  }

  static fetchContractFilters(contracts: ContractType[]) {
    if (contracts) {
      const month: ContractFilterDateType[] = this.fetchContractGroup(contracts);
      const status: ContractFilterStatusType[] = this.fetchStatus(contracts);

      return new HistoryFilter(month, status);
    }
  }


  ////////// STATIC FILTER CONTRACTS ////////////////////////////////////////////////////////
  static filter(filters: HistoryFilter, contracts: ContractType[]) {
    const secondLevelFilteredContracts = this.filterByGroup(filters, contracts);

    return this.filterByStatus(filters, secondLevelFilteredContracts);
  }


  static filterByGroup(pendingContractFilter: HistoryFilter, contracts: ContractType[]) {
    // get changed product filters
    let allContracts = true;

    // Filter products by product name
    const filteredPendingContracts = contracts.filter(data => {
      const index = pendingContractFilter.month.findIndex(x => x.name === data.contractGroup1);
      if (index > -1) {
        // uncheck allProduct button
        if (pendingContractFilter.month[index].selected) {
          allContracts = false;
        }

        return pendingContractFilter.month[index].selected;
      } else {
        return true;
      }
    });

    if (allContracts) {
      return contracts;
    }

    return filteredPendingContracts;
  }


  static filterByStatus(pendingContractFilter: HistoryFilter, contracts: ContractType[]) {
    // get changed product filters
    let allContracts = true;

    // reset term filter display
    pendingContractFilter.status.forEach((item, index) => {
      pendingContractFilter.status[index].display = false;
    });

    // Filter products by term
    const filteredContracts = contracts.filter(data => {
      //  const statusName = this.getStatusName(data.status);
      const index = pendingContractFilter.status.findIndex(x => x.name === data.status);
      if (index > -1) {
        // uncheck allProduct button
        if (pendingContractFilter.status[index].selected) {
          allContracts = false;
        }
        pendingContractFilter.status[index].display = true;

        return pendingContractFilter.status[index].selected;
      } else {
        return true;
      }
    });

    if (allContracts) {
      return contracts;
    }

    return filteredContracts;
  }
}

